module.exports = __webpack_public_path__ + "img/not-labeled.a074c9cb.svg";